import { FC, useEffect, useRef, useState } from "react";

import Table from "@components/Table/index";
import CustomModal from "@components/customModel";
import { IModal, IVersion } from "@types";
import { getVersionsColumns } from "../config";
import {
  ErrorServices,
  useFetchJobGradeVersionsQuery,
  useUpdateJobGradeVersionMutation,
} from "@services";
import { useTypedSelector } from "@hooks";

interface IGradeSetupVersions extends IModal {
  download: (id?: number) => Promise<void>;
}

const GradeSetupVersions: FC<IGradeSetupVersions> = ({
  isVisible,
  setIsVisible,
  download,
}) => {
  const { company } = useTypedSelector(state => state.auth.user!);
  const { id: company_id } = company!;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [versionId, setVersionId] = useState<number | null>(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadingVersionId = useRef<number | null>(null);

  const { data: versions, isLoading } = useFetchJobGradeVersionsQuery({
    page,
    pageSize,
    company_id,
  });

  const [updateJobGradeVersion] = useUpdateJobGradeVersionMutation();

  const { data, pagination } = versions || {};

  useEffect(() => {
    if (data?.length) {
      const activeVersion = data.find(
        (version: IVersion) => version.is_active === "TRUE"
      );

      if (activeVersion?.id) {
        setVersionId(activeVersion.id);
      }
    }
  }, [data]);

  const handleActive = async (id: number) => {
    try {
      setVersionId(id);

      await updateJobGradeVersion({
        id,
        company_id,
      }).unwrap();
    } catch (error) {
      ErrorServices(error);
    }
  };

  const handleDownload = async (id?: number) => {
    try {
      setIsDownloading(true);
      downloadingVersionId.current = id ?? null;

      await download(id);
    } catch (error) {
      ErrorServices(error);
    } finally {
      setIsDownloading(false);
      downloadingVersionId.current = null;
    }
  };

  const versionsColumns = getVersionsColumns({
    handleActive,
    versionId,
    download: handleDownload,
    isDownloading,
    downloadingVersionId,
  });

  return (
    <CustomModal
      isVisible={isVisible}
      title="Previous Versions of Job Grades"
      onClose={() => setIsVisible(false)}
      footer={null}
      width="w-3/4"
      height="80vh"
      bg="bg-white"
    >
      <Table
        isLoading={isLoading}
        data={data}
        columns={versionsColumns}
        pagination
        customStyles="mx-4"
        count={pagination?.count}
        onChangePage={setPage}
        onPageSizeChange={setPageSize}
        page={page}
      />
    </CustomModal>
  );
};

export default GradeSetupVersions;